import { request, RespError, handleFormatRes, formatFaceUrlNickname } from '../../utils';
import { GET_USER_INFO } from '../../config/url';
// 需要转成 int 型的 key 数组
const needParseIntKey = [];
// 需要转成 date 型的 key 数组
const needParseDateKey = [];
/**
 * 获取用户头像和昵称（可用于高授权探测）
 * 返回错误码8598998014则表示未高授权
 *
 * 接口地址：`/app/promotion/prom_user_info.cgi`
 *
 * @param actId 注意!需要让后端配置这个actId(或者用hk_summer_prom这个actId)
 * @returns
 */
export async function getUserInfo({ actId }) {
    try {
        // 参数格式化
        const params = {
            t: new Date().getTime(),
            act_id: actId,
        };
        // 接口请求
        const result = await request.get(GET_USER_INFO, { params });
        if (result) {
            // 正常的返回
            if ((result === null || result === void 0 ? void 0 : result.retcode) === '0') {
                const res = handleFormatRes({
                    result, needParseIntKey, needParseDateKey, transformer: (res) => (Object.assign(Object.assign({}, res), formatFaceUrlNickname(res.faceUrl, res.nickName))),
                });
                return res;
            }
            // 状态码错误的返回
            throw new RespError(result.retcode, result.retmsg, result);
        }
        throw result;
    }
    catch (error) {
        throw error;
    }
}
